import { PlayCircleRounded } from '@mui/icons-material';
import { Container } from 'react-bootstrap';
import { imageUrl } from '../../config/apiUrl';
import Button from '../Button/Button';
import classes from './HeroSection.module.css';
// import { useNavigate } from 'react-router-dom';

function HeroSection({
  id = 'hero',
  containerClass = '',
  children,
  minHeight = '',
  bgImage,
  className = '',
  heroData,
  center = false
}) {
  // const navigate = useNavigate();
  return (
    <>
      <style>{`
    .bgImg{
      background-image: url(${bgImage});
      background-repeat: no-repeat;
      background-size: cover;
    }
    `}</style>
      <div id={id} className={[classes.heroSection, className].join(' ')}>
        <Container
          className={['bgImg', classes.heroContainer].join(' ')}
          style={{ minHeight: minHeight }}>
          {/* <picture >
            <img src={bgImage} />
          </picture> */}
          <div className={classes.textDiv}>
            {heroData?.photo && (
              <div className={classes.imgDiv}>
                <img src={imageUrl(heroData?.photo)} />
              </div>
            )}
            <h1>{heroData?.title}</h1>
            <h6 className={classes.subtitle}>{heroData?.subTitle}</h6>
            <h6>{heroData?.subTitle2}</h6>
            {heroData?.toggle && (
              <Button
                leftIcon={<PlayCircleRounded />}
                className="mt-3"
                variant="whiteOutlineTrasparent"
                label={heroData?.linkText}
                onClick={() => {
                  window.open(heroData?.link, '_self');
                }}
              />
            )}
          </div>
          <Container className={[containerClass, center && classes.center].join(' ')}>
            {children}
          </Container>
        </Container>
      </div>
    </>
  );
}

export default HeroSection;
